// extracted by mini-css-extract-plugin
module.exports = {"slot":"Slot_slot__w9q1w","weekend":"Slot_weekend__mnagf","stale":"Slot_stale__6yp8r","statusText":"Slot_statusText__orvoc","statusLabelLink":"Slot_statusLabelLink__d0ms_"};